<template>
  <div class="q-gutter-y-sm">
    <q-item clickable class="item" active-class="item-active" to="/system/users">
      <q-item-section avatar>
        <q-icon size="md" name="group" />
      </q-item-section>

      <q-item-section>Admin Users</q-item-section>

      <q-tooltip anchor="center right" self="center left">Admin Users</q-tooltip>
    </q-item>

    <q-item clickable class="item" active-class="item-active" to="/system/roles">
      <q-item-section avatar>
        <q-icon size="md"><RoleIcon /></q-icon>
      </q-item-section>

      <q-item-section>Admin Roles</q-item-section>

      <q-tooltip anchor="center right" self="center left">Admin Roles</q-tooltip>
    </q-item>

    <q-item clickable class="item" active-class="item-active" to="/system/advertising-management">
      <q-item-section avatar>
        <q-icon size="md"><AdIcon /></q-icon>
      </q-item-section>

      <q-item-section>Advertising</q-item-section>

      <q-tooltip anchor="center right" self="center left">Advertising</q-tooltip>
    </q-item>

    <q-item clickable class="item" active-class="item-active" to="/system/faq">
      <q-item-section avatar>
        <q-icon size="md"><FaqIcon /></q-icon>
      </q-item-section>

      <q-item-section>FAQ</q-item-section>

      <q-tooltip anchor="center right" self="center left">FAQ</q-tooltip>
    </q-item>

    <q-item clickable class="item" active-class="item-active" to="/system/activity-log">
      <q-item-section avatar>
        <q-icon size="md"><LogIcon /></q-icon>
      </q-item-section>

      <q-item-section>Activity Log</q-item-section>

      <q-tooltip anchor="center right" self="center left">Activity Log</q-tooltip>
    </q-item>

    <q-item clickable class="item" active-class="item-active" to="/system/event-log">
      <q-item-section avatar>
        <q-icon size="sm" name="event_note" />
      </q-item-section>

      <q-item-section>Event Log</q-item-section>

      <q-tooltip anchor="center right" self="center left">Event Log</q-tooltip>
    </q-item>
  </div>
</template>

<script>
import RoleIcon from '@/assets/icons/role.svg';
import AdIcon from '@/assets/icons/ads.svg';
import FaqIcon from '@/assets/icons/faq.svg';
import LogIcon from '@/assets/icons/log.svg';

export default {
  components: {
    RoleIcon,
    AdIcon,
    FaqIcon,
    LogIcon,
  },
};
</script>
